var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoachingSessionIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 11.857,
    height: 20.157,
    viewBox: "0 0 11.857 20.157",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1980",
    "data-name": "Rectangle 1980",
    width: 11.857,
    height: 20.157,
    fill: "#040227"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22138",
    "data-name": "Group 22138",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11220",
    "data-name": "Path 11220",
    d: "M10.971,0H.914A.914.914,0,0,0,0,.914v11.58a.914.914,0,0,0,.914.914h.609v.3a.609.609,0,0,0,.609.609h.884L1.579,18.276a.9.9,0,0,0,.029.695A.914.914,0,0,0,3.3,18.9l1.579-4.342V17.98a.914.914,0,1,0,1.828,0V14.557L8.283,18.9a.918.918,0,0,0,.859.6.9.9,0,0,0,.311-.056.914.914,0,0,0,.518-.477A.9.9,0,0,0,10,18.277L8.563,14.323h.884a.609.609,0,0,0,.609-.609v-.3h.914a.914.914,0,0,0,.914-.914V.914A.914.914,0,0,0,10.971,0M2.725,18.691a.3.3,0,0,1-.16.174.294.294,0,0,1-.229.01.308.308,0,0,1-.174-.16.3.3,0,0,1-.009-.229l1.515-4.162h.647Zm3.37-.711a.3.3,0,1,1-.609,0V14.323h.609Zm3.334.507a.3.3,0,0,1-.01.228.308.308,0,0,1-.176.161.3.3,0,0,1-.228-.01.3.3,0,0,1-.16-.174L7.267,14.323h.647ZM6.4,13.713H2.133V12.494H9.447v1.219Zm4.876-1.219a.3.3,0,0,1-.3.3h-.914v-.3a.609.609,0,0,0-.609-.609H2.133a.609.609,0,0,0-.609.609v.3H.914a.3.3,0,0,1-.3-.3V.914a.3.3,0,0,1,.3-.3H10.971a.3.3,0,0,1,.3.3Z",
    transform: "translate(-0.028 0.654)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11221",
    "data-name": "Path 11221",
    d: "M41.142,32H32.3a.3.3,0,0,0-.3.3v9.447a.3.3,0,0,0,.3.3h8.837a.3.3,0,0,0,.3-.3V32.3a.3.3,0,0,0-.3-.3m-.3,9.447H32.609V32.609h8.228Z",
    transform: "translate(-30.809 -30.127)",
    fill: "#040227"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoachingSessionIcon);
export default __webpack_public_path__ + "static/media/coaching-session-icon.4dc3f2f8d229e9977465e9cb23493438.svg";
export { ForwardRef as ReactComponent };